<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chaptitle">Cast of Characters</h2>
<p class="noindent_n"><span class="bold">John J. Malone:</span> Short and little plump, always disheveled, he does not look like a lawyer but he could get a girl “out of trouble if she’d committed a mass murder in an orphanage, with seventeen policemen for witnesses.”</p>
<p class="noindent_n"><span class="bold">Jake Justus:</span> He’s been many things but right now he’s the press agent and manager for a band leader.</p>
<p class="noindent_n"><span class="bold">Helene Brand:</span> For a Northshore deb, she’s a handful and perfectly capable of holding her own. But what’s her connection to the family of the victim?</p>
<p class="noindent_n"><span class="bold">Holly Inglehart:</span> A young redhead, she’s just married a man the victim didn’t approve of. Is that motive enough for murder?</p>
<p class="noindent_n"><span class="bold">Glen Inglehart:</span> Her black-haired fraternal twin. He stands to inherit every-thing now but he’s standing by his sister.</p>
<p class="noindent_n"><span class="bold">Dick Dayton:</span> He’s the band leader and a pretty successful one. He doesn’t <em class="italic">want</em> to believe his bride is guilty.</p>
<p class="noindent_n"><span class="bold">O.O. Featherstone:</span> The victim’s attorney. There was time when he might have married her.</p>
<p class="noindent_n"><span class="bold">Ambrose Parkins:</span> The butler, he firmly believes in Holly’s innocence. What is it that he knows?</p>
<p class="noindent_n"><span class="bold">Nellie Parkins:</span> His wife and the cook. Why is she so scared?</p>
<p class="noindent_n"><span class="bold">Maybelle Parkins:</span> She’s a bit of a floozie and is keen on Glen.</p>
<p class="noindent_n"><span class="bold">Hyme Mendel:</span> He’s the District Attorney. He doesn’t much like rich people.</p>
<p class="noindent_n"><span class="bold">Andy Ahearn:</span> The sheriff, he suspects Jake and Helene are up to no good.</p>
<p class="noindent_n"><span class="bold">Jasper Fleck:</span> The chief of police, he knows they’re up to no good.</p>
<p class="noindent_n"><span class="bold">Al Hedberg:</span> The coroner. He just cares about bodies.</p>
<p class="noindent_n"><span class="bold">Butch:</span> Helene’s chauffeur. From time to time he “gets in jail for something” but he’s a good man to have around.</p>
<p class="noindent_n"><span class="bold">Lewis Miller:</span> He’s a dapper little man in a derby hat and a chesterfield overcoat. He’s more important that he looks.</p>
<p class="noindent_n"><span class="bold">Dr. Kendall:</span> He’s known to look the other way when Helene gets into trouble.</p>
<p class="noindent_n"><span class="bold">Mrs. Fraser:</span> She runs a very nice brothel, has a daughter who is an honor student and likes to knit. Besides every story needs a whore with a heart of gold.</p>
<p class="noindent_n"><span class="bold">Aunt Alexandria Inglehart:</span> The victim. Absolutely no one liked her.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM01.vue?455e24ec